import {FormButton, FormControl} from 'platform/components';

import {useWatch} from 'react-hook-form';

import i18n from '@dms/i18n';

import {RequiredTestIdProps} from 'shared/web';

import {CreateSupplierOrdersFormValues} from '../schemas/createSupplierOrdersFormSchema';

interface CreateSupplierOrdersButtonProps extends RequiredTestIdProps {
  control: FormControl<CreateSupplierOrdersFormValues>;
}

export function CreateSupplierOrdersButton(props: CreateSupplierOrdersButtonProps) {
  const warehouses = useWatch({control: props.control, name: 'warehouses'});
  const hasSelectedWarehouse = warehouses.some((warehouse) => warehouse.isSelected);

  return (
    <FormButton
      control={props.control}
      type="submit"
      title={i18n.t('general.actions.create')}
      isDisabled={!hasSelectedWarehouse}
      data-testid={props['data-testid']}
    />
  );
}
